import { useAppDispatch, useAppSelector } from "../../../app/store";
import { CommonJobsStatus } from "../../../api/aiInsights";
import { useState } from "react";
import { selectInsightConfig } from "../logic/aiInsightsSelectors";
import { AIInsightExtended } from "../logic/aiInsightsSlice";
import { fetchInsightsThunk, generateInsightsThunk } from "../logic/aiInsightsThunk";
import { useParams } from "react-router-dom";
import { getCurrentCaseProduct } from "../../caseinfo/logic/Slice";

interface AIInsightCardProps {
  insight: AIInsightExtended;
  previewLength?: number;
}

const AIInsightCard: React.FC<AIInsightCardProps> = ({ 
  insight, 
  previewLength = 250 
 }) => {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useAppDispatch();

  const insightConfig = useAppSelector(selectInsightConfig(insight.insight_key));

  const answer = insight.insight_details?.answer || "";

  const isLong = answer.length > previewLength;
  const displayText = expanded ? answer : answer.slice(0, previewLength) + (isLong ? "..." : "");

  const { id: caseId } = useParams<{ id: string }>();
  const product = useAppSelector(getCurrentCaseProduct);

  const generateInsight = () => {
    if(caseId && product){
      dispatch(generateInsightsThunk({
        caseId:caseId,
        product: product,
        insightKeys:[insight.insight_key]
      }))
    }
  }

  const reloadInsight = () => {
      if(caseId) {
          dispatch(fetchInsightsThunk({ 
            caseId: caseId,
            insightKeys:  [insight.insight_key]
          }));
      }
  }

  return (
    <div className="w-full bg-white shadow-lg rounded-2xl p-6 border border-gray-200 mb-4">
      {/* Category */}
      <div className="text-sm font-semibold text-indigo-600 mb-4">
        {insightConfig.category}
      </div>

      {/* Question */}
      <h2 className="text-lg font-bold text-gray-900 mb-2">{insightConfig.question_text}</h2>

      {/* Answer */}

      {insight.loadingStatus === 'loading' &&
        <p>Loading Insight</p>
      }

      {insight.loadingStatus === 'failed' &&
        <>
          <p>Failed to Load Insight. Please Retry</p>
          <button onClick={reloadInsight}>Retry</button>
        </>
      }

      {(insight.status === CommonJobsStatus.SUBMITTED || insight.status === CommonJobsStatus.IN_PROGRESS) &&
        // todo: styling
        <>
          <p>Generating Insight...</p>
          <button onClick={reloadInsight}>Refresh status</button>
        </>
        
      }

      {(insight.status === CommonJobsStatus.FAILED) &&
        // todo: styling
        <>
          <p>Failed to generate Insight.</p>
          <button onClick={generateInsight}>Retry</button>
        </>
        
      }

      {insight.status === CommonJobsStatus.AVAILABLE &&
        <>
          <p className="text-gray-700 text-sm leading-relaxed">
            {displayText}
          </p>

          {/* Toggle Button */}
          {isLong && (
            <button
              onClick={() => setExpanded(!expanded)}
              className="mt-2 text-indigo-600 text-sm font-medium hover:underline focus:outline-none"
            >
              {expanded ? "View less" : "View more"}
            </button>
          )}
        </>
      }
      
    </div>
  );
};

export default AIInsightCard;